var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isApplicationOutdated
    ? _c(
        "div",
        {
          staticClass: "w-100",
          staticStyle: { position: "fixed", top: "100px", "z-index": "1001" },
        },
        [
          _c(
            "b-container",
            [
              _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("div", { staticClass: "flex-grow-1" }, [
                    _vm._v(
                      "\n                    Es wurde eine neue Version veröffentlicht.\n                    Bitte Laden Sie autoclaim neu, um Probleme zu vermeiden.\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "secondary" },
                          on: { click: _vm.reloadApplication },
                        },
                        [
                          _vm._v(
                            "\n                        Hier neu laden\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }